import React from 'react'

import { Link } from 'react-router-dom'

import {
  PageIntroContainer,
  LogoImage,
  ButtonContainer,
  Text,
  ButtonLogin,
  ButtonSignup,
  ButtonPolicy,
  Header,
} from './styles'

import logoImage from '../../../../assets/png/logo-intro.png'
import grupoIntro from '../../../../assets/svg/GrupoIntro.svg'
import arrowLeft from '../../../../assets/svg/arrow-left-line.svg'

import IProps from './props'

const PageIntroContractors: React.FC<IProps> = ({ handleBackClick }) => (
  <>
    <Header>
      <button
        type="button"
        onClick={handleBackClick}
        style={{ textDecoration: 'none', background: 'none', border: 'none' }}
      >
        <img src={arrowLeft} alt="Logo" />
        Contratante - Login / Cadastro
      </button>
    </Header>
    <PageIntroContainer>
      <LogoImage src={logoImage} alt="Logo" />
      <LogoImage src={grupoIntro} alt="Logo" />
      <Text>
        Seja bem-vindo à maior plataforma de busca por médicos do Brasil!
      </Text>
      <ButtonContainer>
        <Link to="/signin" style={{ textDecoration: 'none' }}>
          <ButtonLogin>Fazer login</ButtonLogin>
        </Link>
        <Link to="/signup/contractor" style={{ textDecoration: 'none' }}>
          <ButtonSignup>Primeira vez? Cadastre-se</ButtonSignup>
        </Link>
        <Link to="/privacyPolice" style={{ textDecoration: 'none' }}>
          <ButtonPolicy>Política de privacidade</ButtonPolicy>
        </Link>
      </ButtonContainer>
    </PageIntroContainer>
  </>
)

export default PageIntroContractors
